// extracted by mini-css-extract-plugin
export default {"cart_item_image":"cart_item_card_cart_item_image__AET+H"};